<!-- <div class="top-container">
  <div class="p-1 mdlz-card-value-container Total-lines-required">
    <div class="mdlz-card-subtext"></div>
      <div class="fs-1 mdlz-card-value Total-lines-required"
           *ngIf="chartData?.new_line.length > 0">{{ chartData?.new_line | arraySum | number : '1.0-0' }}</div>
  </div>
  <div style="border: 1px solid #917ba6"></div>
  <div class="p-1 mdlz-card-value-container">
    <div class="mdlz-card-subtext"></div>
    <div class="d-flex align-items-center">
      <div class="fs-1 mdlz-card-value"
           *ngIf="chartData?.fte.length > 0">{{ chartData?.fte | arraySum | number : '1.0-0' }}</div>
    </div>
  </div>
</div> -->
<div class="lines">
  <div class="top-container mt-3">
    <div
      *ngFor="let item of fteDataLabel; let i = index"
      [ngClass]="[i < fteDataLabel.length - 1 ? 'partition' : '', view == 'simulation' ? 'data-wrapper-simulation' : 'data-wrapper']"
    >
      <p class="mdlz-card-subtext">{{ item.label }}</p>
      <div class="data-content">
        <!-- <h4 class="mdlz-card-value">{{ item.value | arraySum | number : '1.0-1' }}</h4> -->
         <h4 class="mdlz-card-value">{{ item.value | number : '1.0-1' }}</h4>
      </div>
    </div>
  </div>
  <div class="chart-card">
    <!-- <div class="legend-container mb-3">
    <div class="legend-item bar1"></div>
    <span>Lines</span>
    <div class="legend-item bar2 ms-4"></div>
    <span>FTEs</span>
  </div> -->
    <div id="chart-box">
      <div class="colSmall">
        <canvas id="barChart2"></canvas>
      </div>
      <div class="colLarge">
        <div class="box" #chartBox>
          <canvas id="barChart1"></canvas>
        </div>
      </div>
    </div>
  </div>
</div>
